import { render, staticRenderFns } from "./DebugPermissions.vue?vue&type=template&id=ea55e788&scoped=true"
import script from "./DebugPermissions.vue?vue&type=script&lang=js"
export * from "./DebugPermissions.vue?vue&type=script&lang=js"
import style0 from "./DebugPermissions.vue?vue&type=style&index=0&id=ea55e788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea55e788",
  null
  
)

export default component.exports